import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import Messages from './sendSetting/Messages';
import Name from './sendSetting/Name';
import SkipOOS from './sendSetting/SkipOOS';
import Wait from './sendSetting/Wait';
import Mask from './SettingBarMask';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
    hr: {
      padding: 0,
      width: '100%',
      height: 1,
      background: color.$9,
      margin: '36px 0',
    },
  },
  {
    name: 'MessageSetting',
  },
);

const MessageSetting = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.top}>{t('add-message')}</div>
      <div id="message-setting-bar-bottom" className={classes.bottom}>
        <Wait />
        <SkipOOS />
        <hr className={classes.hr} />
        <Name />
        <Messages />
      </div>
      <Mask mainId="message-setting-bar-bottom" />
    </>
  );
};

export default MessageSetting;
